import React, { Component } from 'react';
import ReactNotification from 'react-notifications-component';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import { MODALACTION, RESPONSE } from '../../config/constants';
import {Panel, PanelBody, PanelHeader} from '../../components/panel/panel';
import Services from '../../services/service';
import { isEmptyObject } from 'jquery';
import MyDocument from './preview-template';
import { PDFViewer } from '@react-pdf/renderer';

const { CREATE, DELETE } = MODALACTION;
const { SUCCESS } = RESPONSE;

class LayoutPublicWebVisitor extends Component {
  constructor(props){
    super(props);
    this.state = {
      modalAddComponent: false,
      modalAddDisclaimer: false,
      actionModal: '',
      layoutData: [],
      disclaimer: '',
      value: '',
      selectedItem: {},
      type: '',
      length: '',
      label: '',
      preview: false
    }
  }

  componentDidMount() {
    this.getPublicWeb();
  }

  getPublicWeb = () => {
    Services.getPublicWeb()
      .then(res => {
        this.setState({ layoutData: res })
      })
      .catch(err => console.log(err))
  };

  renderBreadCrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">Layout Public Web Visitor</li>
      </ol>
      <h1 className="page-header">Layout Public Web Visitor </h1>
    </div>
  );

  renderFormTitle = (title) => (
    <div className="col-xl-12" style={{ marginTop: '20px' }}>
      <label>Judul</label>
      <input
        type="text"
        className="form-control"
        defaultValue={title ?  title : ''}
      />
    </div>
  );

  renderFormDescription = (desc) => (
    <div className="col-xl-12" style={{ marginTop: '10px' }}>
      <label>Description</label>
      <textarea
        type="text"
        className="form-control"
        defaultValue={desc ? desc : ''}
      />
    </div>
  );

  handleFieldChange = (key) => (e) => {
    const state = { [key]: e.target.value };
    this.setState(state);
  }

  toggleAddComponent = (action = '', item = {}) => {
    this.setState({
      modalAddComponent: !this.state.modalAddComponent,
      actionModal: action,
      selectedItem: item
    });
  };

  toggleAddDisclaimer = (action = '', item = {}) => {
    this.setState({
      modalAddDisclaimer: !this.state.modalAddDisclaimer,
      actionModal: action,
      selectedItem: item
    });
  };

  toggleNotification = action => {
    switch(action){
      case SUCCESS:
        this.addNotification('success', 'Success', 'All your data has been successfully updated', 'top-right');
        break;
        break;
      default:
        break;
    }
  };

  handleSubmitComponent = () => {
    const { label, length, type, layoutData } = this.state;
    const newComponent = {
      label: label,
      length: length,
      type: type,
      active: true
    };
    layoutData.componentData.push(newComponent);
    const payload = {
      componentData: this.state.layoutData.componentData,
      disclaimerData: this.state.layoutData.disclaimerData,
      title: this.state.layoutData.title,
      desc: this.state.layoutData.desc,
      active: true
    };
    Services.addPublicWeb(payload)
      .then(res => {
        this.setState({ modalAddComponent: false });
        this.toggleNotification(SUCCESS);
        this.getPublicWeb();
      })
      .catch(err => console.log(err))
  };

  handleDeleteComponent = () => {
    const { layoutData, selectedItem } = this.state;
    let componentData = layoutData.componentData;
    componentData = componentData.filter(data => data._id !== selectedItem._id);
    const payload = {
      title: this.state.layoutData.title,
      desc: this.state.layoutData.desc,
      active: true,
      componentData: componentData,
      disclaimerData: this.state.layoutData.disclaimerData
    };
    Services.addPublicWeb(payload)
      .then(res => {
        this.getPublicWeb();
        this.setState({ modalAddComponent: false });
        this.toggleNotification(SUCCESS);
      })
      .catch(err => console.log(err))
  };

  handleSubmitDisclaimer = () => {
    const { disclaimer, value, layoutData } = this.state;
    const newDisclaimer = {
      disclaimer: disclaimer,
      value: value,
      active: true
    };
    layoutData.disclaimerData.push(newDisclaimer);
    const payload = {
      title: this.state.layoutData.title,
      desc: this.state.layoutData.desc,
      active: true,
      componentData: this.state.layoutData.componentData,
      disclaimerData: this.state.layoutData.disclaimerData
    };
    Services.addPublicWeb(payload)
      .then(res => {
        this.setState({ modalAddDisclaimer: false });
        this.toggleNotification(SUCCESS);
        this.getPublicWeb();
      })
      .catch(err => console.log(err))
  };

  handleDeleteDisclaimer = () => {
    const { layoutData, selectedItem } = this.state;
    let disclaimerData = layoutData.disclaimerData;
    disclaimerData = disclaimerData.filter(data => data._id !== selectedItem._id);
    const payload = {
      title: this.state.layoutData.title,
      desc: this.state.layoutData.desc,
      active: true,
      componentData: this.state.layoutData.componentData,
      disclaimerData: disclaimerData
    };
    Services.addPublicWeb(payload)
      .then(res => {
        this.getPublicWeb();
        this.setState({ modalAddDisclaimer: false });
        this.toggleNotification(SUCCESS);
      })
      .catch(err => console.log(err))
  };

  toggleAddModalComponent = (action = '', item = {}) => {
    this.setState({
      modalAddComponent: !this.state.modalAddComponent,
      actionModal: action,
      selectedItem: item
    });
  };

  toggleAddModalDisclaimer = (action = '', item = {}) => {
    this.setState({
      modalAddDisclaimer: !this.state.modalAddDisclaimer,
      actionModal: action,
      selectedItem: item
    });
  }

  setActionButtonComponent = (value) => {
    switch (value) {
      case CREATE :
        this.handleSubmitComponent();
        break;
      case DELETE :
        this.handleDeleteComponent();
        break;
      default:
        break;
    }
  };

  setActionButtonDisclaimer = (value) => {
    switch (value) {
      case CREATE :
        this.handleSubmitDisclaimer();
        break;
      case DELETE :
        this.handleDeleteDisclaimer();
        break;
      default:
        break;
    }
  };

  setHeaderComponent = (value) => {
    switch (value) {
      case CREATE :
        return 'Tambah Komponen';
      case DELETE :
        return 'Are you sure want to delete?';
      default:
        return '';
    }
  };

  setHeaderDisclaimer = (value) => {
    switch (value) {
      case CREATE :
        return 'Tambah Disclaimer';
      case DELETE :
        return 'Are you sure want to delete?';
      default:
        return '';
    }
  };

  renderAddComponentModal = () => {
    const { actionModal, selectedItem, type, length, label } = this.state;
    const textHeader = this.setHeaderComponent(actionModal);
    const filled = isEmptyObject(selectedItem);
    return(
      <Modal isOpen={this.state.modalAddComponent} toggle={() => this.toggleAddComponent()}>
        <ModalHeader toggle={() => this.toggleAddComponent()}>{textHeader}</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Pilih Komponen</label>
            <select
              onChange={this.handleFieldChange('type')}
              className="form-control"
              defaultValue={!filled ? selectedItem.type : type}
              disabled={actionModal === DELETE}
            >
              <option value="">Select Option</option>
              <option value="textbox">Text Box</option>
            </select>
          </div>
          <div className="form-group">
            <label>Panjang Input</label>
            <input
              onChange={this.handleFieldChange('length')}
              type="text"
              className="form-control"
              defaultValue={!filled ? selectedItem.length : length}
              disabled={actionModal === DELETE}
            />
          </div>
          <div className="form-group">
            <label>Label Judul</label>
            <input
              onChange={this.handleFieldChange('label')}
              type="text"
              className="form-control"
              defaultValue={!filled ? selectedItem.label : label}
              disabled={actionModal === DELETE}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.toggleAddComponent()}>Cancel</button>
          <button className="btn btn-primary" onClick={() => this.setActionButtonComponent(actionModal)}>{actionModal}</button>
        </ModalFooter>
      </Modal>
    )
  };

  renderAddDisclaimerModal = () => {
    const { actionModal, selectedItem, disclaimer, value } = this.state;
    const textHeader = this.setHeaderDisclaimer(actionModal);
    const filled = isEmptyObject(selectedItem);
    return(
      <Modal isOpen={this.state.modalAddDisclaimer} toggle={() => this.toggleAddDisclaimer()}>
        <ModalHeader toggle={() => this.toggleAddDisclaimer()}>{textHeader}</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Disclaimer</label>
            <textarea
              onChange={this.handleFieldChange('disclaimer')}
              type="text"
              className="form-control"
              defaultValue={!filled ? selectedItem.disclaimer : disclaimer}
              disabled={actionModal === DELETE}
            />
          </div>
          <div className="form-group">
            <label>Bobot</label>
            <input
              onChange={this.handleFieldChange('value')}
              type="text"
              className="form-control"
              defaultValue={!filled ? selectedItem.value : value}
              disabled={actionModal === DELETE}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.toggleAddDisclaimer()}>Cancel</button>
          <button className="btn btn-primary" onClick={() => this.setActionButtonDisclaimer(actionModal)}>{actionModal}</button>
        </ModalFooter>
      </Modal>
    )
  };

  renderFormComponent = () => {
    const { layoutData: { componentData = [] }  } = this.state;
    let no = 0;
    return (
      <div className="col-xl-12" style={{ marginTop: '30px' }}>
        <Panel>
          <PanelHeader noButton={true}>
            <div className="d-flex justify-content-xl-between">
              <h5>Komponen Form</h5>
              <button className="btn btn-sm btn-primary width-70" onClick={() => this.toggleAddComponent(CREATE)}>Add</button>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="table-responsive">
              <table className="table table-striped m-b-0">
                <thead>
                <tr>
                  <th>No</th>
                  <th>Komponen</th>
                  <th>Panjang</th>
                  <th>Label</th>
                  <th>Required</th>
                  <th width="1%">Action</th>
                </tr>
                </thead>
                <tbody>
                { componentData.map((item, index) => {
                  no++;
                  return (
                    <tr key={index}>
                      <td>{no}</td>
                      <td>{item.type}</td>
                      <td>{item.length}</td>
                      <td>{item.label}</td>
                      <td>True</td>
                      <td className="with-btn text-nowrap">
                        <button
                          onClick={() => this.toggleAddModalComponent(DELETE, item)}
                          className="btn btn-sm btn-danger width-60">Delete</button>
                      </td>
                    </tr>
                  )
                })}
                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    )
  };

  renderDisclaimerParameter = () => {
    const { layoutData: { disclaimerData = [] }  } = this.state;
    let no = 0;
    return (
      <div className="col-xl-12" style={{ marginTop: '30px' }}>
        <Panel>
          <PanelHeader noButton={true}>
            <div className="d-flex justify-content-xl-between">
              <h5>Disclaimer Parameter</h5>
              <button className="btn btn-sm btn-primary width-70" onClick={() => this.toggleAddDisclaimer(CREATE)}>Add</button>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="table-responsive">
              <table className="table table-striped m-b-0">
                <thead>
                <tr>
                  <th>No</th>
                  <th>Disclaimer</th>
                  <th>Bobot</th>
                  <th width="1%">Action</th>
                </tr>
                </thead>
                <tbody>
                { disclaimerData.map((item, index) => {
                  no++;
                  return (
                    <tr key={index}>
                      <td>{no}</td>
                      <td>{item.disclaimer}</td>
                      <td>{item.value}</td>
                      <td className="with-btn text-nowrap">
                        <button
                          onClick={() => this.toggleAddModalDisclaimer(DELETE, item)}
                          className="btn btn-sm btn-danger width-60">Delete</button>
                      </td>
                    </tr>
                  )
                })}
                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    )
  };

  renderForm = () => {
    const { title, desc } = this.state.layoutData;
    return(
      <div>
        {this.renderFormTitle(title)}
        {this.renderFormDescription(desc)}
        {this.renderFormComponent()}
        {this.renderDisclaimerParameter()}
      </div>
    )
  };

  renderPreview = () => {
    const { layoutData } = this.state;
    return(
      <Modal isOpen={this.state.preview} toggle={() => this.setState({ preview: false })}>
        <ModalHeader toggle={() => this.setState({ preview: false })}>Preview</ModalHeader>
        <ModalBody>
          <PDFViewer width={'100%'} height={700}>
            <MyDocument
              layoutData={layoutData}
            />
          </PDFViewer>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.setState({ preview: false })}>Cancel</button>
        </ModalFooter>
      </Modal>
    )
  };

  renderPreviewButton = () => (
    <div style={{ textAlign: 'center' }}>
      <button
        onClick={() => this.setState({ preview: true })}
        className="btn btn-sm btn-success"
      >
        Preview Page
      </button>
    </div>
  );

  render(){
    return(
      <div>
        <ReactNotification/>
        {this.renderBreadCrumb()}
        {this.renderForm()}
        {this.renderAddComponentModal()}
        {this.renderAddDisclaimerModal()}
        {this.renderPreviewButton()}
        {this.renderPreview()}
      </div>
    )
  }
}

export default LayoutPublicWebVisitor;
